module.exports = __webpack_public_path__ + "static/SpecifyPERSONALExpanded-Black-4a47e48fb2994130f601d8e8a4b81ef6.woff";